module.exports = __webpack_public_path__ + "files/a81c0016d9122ec02547bd6d3999fe0e.png";